import './dns-exceptions-link.scss';
import { Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';
import { useStores } from 'src/components/store';

export const DnsExceptionLink: React.FC<{ value: string }> = observer(({ value }) => {
    const { fwVersionStore, customerStore } = useStores();
    const { selectedCustomer, serviceId } = customerStore;
    if (value !== 'Block' || !selectedCustomer) return null;

    return <Tooltip placement="bottom" overlayClassName="tooltip-explain-dns-exceptions-link" title={tooltipContent}>
        <Link className="dns-exceptions-link-wrapper"
            to={`/${selectedCustomer.customerId}/${serviceId}/protection/version/${fwVersionStore.selectedVersionId}/web-filtering/domains`}>
            <div className="dns-link">Manage DNS Exceptions</div>
        </Link>
    </Tooltip>;
});

const tooltipContent = 'Some of the flagged sites might be essential to your business. ' +
    'You can allow and manage such exceptions on the Domains List.';